import { Component, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Location } from '@angular/common';
import { Notificacion } from '../model/general/notificacion.model';
import { NotificacionService } from '../services/notificacion.service';
import { Login } from '../model/security/login';
import { ModalCredencialesComponent } from 'src/app/notificaciones/modal-credenciales/modal-credenciales.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginDto } from '../model/security/logindto.model';
import { ReestructuraService } from 'src/app/creditos/servicios/reestructura.service';
import { Reestructura } from 'src/app/creditos/modelos/reestructura.model';
import { CreditosService } from 'src/app/creditos/servicios/creditos.service';
import { Msg } from 'src/app/utilerias/mensajes/Msg';

const misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
};

declare var $: any;
@Component({
    selector: 'app-navbar-cmp',
    templateUrl: 'navbar.component.html',
    styleUrls: ['navbar.component.scss'],
    standalone: false
})

export class NavbarComponent implements OnInit {
    private listTitles: any[];
    location: Location;
    mobile_menu_visible: any = 0;
    private nativeElement: Node;
    private toggleButton: any;
    private sidebarVisible: boolean;
    private _router: Subscription;

    login: Login = new Login();
    notificaciones: number = 0;
    listaNot: Notificacion[] = [];
    @ViewChild('app-navbar-cmp', { static: false }) button: any;
    onNotify: boolean = false;

    //Confirmacion de credenciales
    dialogRefCredeciales: MatDialogRef<ModalCredencialesComponent>;
    datosUsuario: LoginDto;

    constructor(location: Location, private renderer: Renderer2, private element: ElementRef, private router: Router,
        private notificacionService: NotificacionService,
        private dialog: MatDialog,
        private reestructuraService: ReestructuraService,
        private msg: Msg,
        private creditoService: CreditosService,
    ) {
        this.location = location;
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;
    }

    minimizeSidebar() {
        const body = document.getElementsByTagName('body')[0];

        if (misc.sidebar_mini_active === true) {
            body.classList.remove('sidebar-mini');
            misc.sidebar_mini_active = false;

        } else {
            setTimeout(function () {
                body.classList.add('sidebar-mini');

                misc.sidebar_mini_active = true;
            }, 300);
        }

        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(function () {
            window.dispatchEvent(new Event('resize'));
        }, 180);

        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(function () {
            clearInterval(simulateWindowResize);
        }, 1000);
    }

    hideSidebar() {
        const body = document.getElementsByTagName('body')[0];
        const sidebar = document.getElementsByClassName('sidebar')[0];

        if (misc.hide_sidebar_active === true) {
            setTimeout(function () {
                body.classList.remove('hide-sidebar');
                misc.hide_sidebar_active = false;
            }, 300);
            setTimeout(function () {
                sidebar.classList.remove('animation');
            }, 600);
            sidebar.classList.add('animation');

        } else {
            setTimeout(function () {
                body.classList.add('hide-sidebar');
                // $('.sidebar').addClass('animation');
                misc.hide_sidebar_active = true;
            }, 300);
        }

        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(function () {
            window.dispatchEvent(new Event('resize'));
        }, 180);

        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(function () {
            clearInterval(simulateWindowResize);
        }, 1000);
    }

    ngOnInit() {
        this.listTitles = [];// ROUTES.filter(listTitle => listTitle);
        this.login = JSON.parse(localStorage.getItem("user"));
        this.consultaNotificacion();

        const navbar: HTMLElement = this.element.nativeElement;
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
        if (body.classList.contains('sidebar-mini')) {
            misc.sidebar_mini_active = true;
        }
        if (body.classList.contains('hide-sidebar')) {
            misc.hide_sidebar_active = true;
        }
        this._router = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            this.sidebarClose();

            const $layer = document.getElementsByClassName('close-layer')[0];
            if ($layer) {
                $layer.remove();
            }
        });
    }

    marcarVisto(notificacion: Notificacion) {
        this.onNotify = false;
        notificacion.estatus_bandeja = 1;
        notificacion.fecha_lectura = new Date().toISOString().split('T')[0];
        this.notificacionService.update(notificacion).subscribe(res => {
            if (res) this.consultaNotificacion();
        });
    }

    marcarVistoTodas() {
        this.listaNot.forEach(notificacion => { if (notificacion.estatus_bandeja == 0) this.marcarVisto(notificacion); });
    }

    sobreNot(value: boolean) {
        this.onNotify = value;
    }

    consultaNotificacion() {
        this.notificacionService.obtenerNotPorUsuario(this.login.usuario.id).subscribe(res => {
            if (res.pmensaje == "ok") {
                this.notificaciones = res.list.length;
                this.listaNot = res.list;
            }
        });
    }

    openDialogCredenciales(row: Notificacion, identificador: number): void {
        this.dialogRefCredeciales = this.dialog.open(ModalCredencialesComponent, {
            disableClose: true,
            autoFocus: true,
            width: '50%',
            data: { withAction: true, viewTypeSearch: true }
        });

        this.dialogRefCredeciales.afterClosed().subscribe(result => {
            this.datosUsuario = result;
            if (this.datosUsuario != null && identificador == 0) {//APROBADA
                this.reestructuraService.obtenerReestructuraPorId(parseInt(row.param3)).subscribe(res => {
                    if (res != null) {
                        this.verificarReestructura(0, row, res);
                    } else this.msg.warningCall("Revisar que la reestructura aún exista", null, null);
                });
            } else if (this.datosUsuario != null && identificador == 1) {//RECHAZADA
                this.reestructuraService.obtenerReestructuraPorId(parseInt(row.param3)).subscribe(res => {
                    if (res != null) {
                        this.verificarReestructura(1, row, res);
                    } else this.msg.warningCall("Revisar que la reestructura aún exista", null, null);
                });
            }
        });
    }

    verificarReestructura(decision: number, row: Notificacion, item: Reestructura) {
        this.reestructuraService.obtenerReestructuraPorId(item.id).subscribe(res1 => {
            if (res1.estatus == "APROBADO") {
                row.estatus_bandeja = 3;
                row.fecha_lectura = new Date().toISOString().split('T')[0];
                this.notificacionService.update(row).subscribe();//se actualiza la notificación
                this.msg.warningCall("La reestructura ya ha sido aprobada por otro usuario de comité", null, result => {
                    this.consultaNotificacion();
                });
            } else if (res1.estatus == "RECHAZADO") {
                row.estatus_bandeja = 4;
                row.fecha_lectura = new Date().toISOString().split('T')[0];
                this.notificacionService.update(row).subscribe();//se actualiza la notificación
                this.msg.warningCall("La reestructura ya ha sido rechazada por otro usuario de comité", null, result => {
                    this.consultaNotificacion();
                });
            } else {//nadie ha tocado la solicitud
                decision == 0 ? this.aprobarReestructura(row, item) : this.rechazarReestructura(row, item);
            }
        });
    }

    aprobarReestructura(row: Notificacion, item: Reestructura) {
        item.estatus = "APROBADO";
        this.creditoService.actualizarReestructura(item).subscribe(res => {
            this.reestructuraService.obtenerReestructuraPorId(item.id).subscribe(res2 => {//verifica que se haya aprobado
                if (res2.estatus == "APROBADO") {
                    row.estatus_bandeja = 3;
                    row.fecha_lectura = new Date().toISOString().split('T')[0];
                    this.notificacionService.update(row).subscribe();//se actualiza la notificación
                    this.msg.successCall("Solicitud Aprobada", null, null);
                    this.consultaNotificacion();
                } else this.msg.warningCall("Revisar que exista pagarés en cobranza", null, null);
            });
        });
    }
    rechazarReestructura(row: Notificacion, item: Reestructura) {
        item.estatus = "RECHAZADO";
        this.creditoService.actualizarReestructura(item).subscribe(res => {
            this.reestructuraService.obtenerReestructuraPorId(item.id).subscribe(res2 => {//verifica que se haya rechazado
                if (res2.estatus == "RECHAZADO") {
                    row.estatus_bandeja = 4;
                    row.fecha_lectura = new Date().toISOString().split('T')[0];
                    this.notificacionService.update(row).subscribe();//se actualiza la notificación
                    this.msg.successCall("Solicitud Rechazada", null, null);
                    this.consultaNotificacion();
                } else this.msg.warningCall("Revisar que exista pagarés en cobranza", null, null);
            });
        });
    }

    onResize(event) {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    }

    sidebarOpen() {
        var $toggle = document.getElementsByClassName('navbar-toggler')[0];
        const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];
        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);
        body.classList.add('nav-open');
        setTimeout(function () {
            $toggle.classList.add('toggled');
        }, 430);

        var $layer = document.createElement('div');
        $layer.setAttribute('class', 'close-layer');


        if (body.querySelectorAll('.main-panel')) {
            document.getElementsByClassName('main-panel')[0].appendChild($layer);
        } else if (body.classList.contains('off-canvas-sidebar')) {
            document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
        }

        setTimeout(function () {
            $layer.classList.add('visible');
        }, 100);

        $layer.onclick = function () { //asign a function
            body.classList.remove('nav-open');
            this.mobile_menu_visible = 0;
            this.sidebarVisible = false;

            $layer.classList.remove('visible');
            setTimeout(function () {
                $layer.remove();
                $toggle?.classList?.remove('toggled');
            }, 400);
        }.bind(this);

        body.classList.add('nav-open');
        this.mobile_menu_visible = 1;
        this.sidebarVisible = true;
    };
    sidebarClose() {
        var $toggle = document.getElementsByClassName('navbar-toggler')[0];
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        var $layer = document.createElement('div');
        $layer.setAttribute('class', 'close-layer');

        this.sidebarVisible = false;
        body.classList.remove('nav-open');
        // $('html').removeClass('nav-open');
        body.classList.remove('nav-open');
        if ($layer) {
            $layer.remove();
        }

        setTimeout(function () {
            $toggle?.classList?.remove('toggled');
        }, 400);

        this.mobile_menu_visible = 0;
    };
    sidebarToggle() {
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    }

    getTitle() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(1);
        }
        for (let i = 0; i < this.listTitles.length; i++) {
            if (this.listTitles[i].type === "link" && this.listTitles[i].path === titlee) {
                return this.listTitles[i].title;
            } else if (this.listTitles[i].type === "sub") {
                for (let j = 0; j < this.listTitles[i].children.length; j++) {
                    let subtitle = this.listTitles[i].path + '/' + this.listTitles[i].children[j].path;
                    if (subtitle === titlee) {
                        return this.listTitles[i].children[j].title;
                    }
                }
            }
        }
        return 'Dashboard';
    }
    getPath() {
        return this.location.prepareExternalUrl(this.location.path());
    }

    goHome(): void {
        this.router.navigate(['/']);
    }
}
